import Component from './CRUD.vue';

export default {
  install(Vue) {
    Vue.component('BkfCrud', Component);
  },
};
